import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import ToolTip from "uis/new-tootip";

const ViolationReservationHeader = () => {
  return (
    <HeaderContainer>
      <LabelContainer minWidth={280} maxWidth={"100%"} style={{ flex: 1 }}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          예약 정보
        </UI.Typography>
      </LabelContainer>
      <LabelContainer minWidth={120} maxWidth={240}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          회의실
        </UI.Typography>
      </LabelContainer>
      <LabelContainer minWidth={100} maxWidth={120}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          참석 인원
        </UI.Typography>
        <ToolTip zIndex={0} icon="info" text="실제 참석 인원 / 최소 참석 인원" position={{ top: -30, left: -87 }} />
      </LabelContainer>
      <LabelContainer minWidth={200} maxWidth={220}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          예약 일시
        </UI.Typography>
      </LabelContainer>
    </HeaderContainer>
  );
};

export default ViolationReservationHeader;

const HeaderContainer = styled.div`
  display: flex;
  min-width: 832px;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  padding: 12px 24px;
  align-items: center;
  gap: 20px;

  border-radius: 12px;
  background-color: var(--component-color-fill-alternative);
`;

const LabelContainer = styled.div<{ minWidth: number; maxWidth: number | string }>`
  display: flex;
  min-width: ${(props) => props.minWidth}px;
  max-width: ${(props) => props.maxWidth}px;
  align-items: center;
  gap: 4px;
  flex: 1;

  p {
    white-space: nowrap;
  }
`;
